export const environment = {
  production: true,
  URL_BASE: 'https://bosques-app.pe/geobosques/',
  API_SERVICES_ADMIN: 'https://app.bosques-app.pe/service-admin-generic',
  API_SERVICES_SECURITY: 'https://app.bosques-app.pe/service-admin-security',
  API_SERVICES_GEO: 'https://app.bosques-app.pe/service-geo-loss',
  API_SERVICES_USO: 'https://app.bosques-app.pe/service-geo-land-use',
  API_SERVICES_ALERT: 'https://app.bosques-app.pe/service-geo-alert',
  API_VISOR: 'https://gis.bosques.gob.pe/portal/apps/experiencebuilder/experience/',

  KEY_VISOR: '54f9953bb61d41b2bbac1b33b00a59c5',

  VAR_TOKEN: 'access_token',
  VAR_REFRESH_TOKEN: 'refresh_token',
  VAR_AUTH: 'auth',
  VAR_USER: 'user',
  
  URL_VISOR: 'https://bosques-app.pe/forest-gis-appweb/',
  URL_MOODLE: 'https://moodle.bosques-app.pe/',

  colorSelectMapFill: [255, 33, 33, 0.1],
  colorSelectMap: [255, 33, 33],
  symbolEditFill: {
    type: 'simple-fill',
    style: 'solid',
    color: [12, 254, 254, 0.2], //--Celeste
    outline: {
      color: [12, 254, 254], //--Celeste
      width: 1.5
    }
  },
  symbolSelectFill: {
    type: 'simple-fill',
    style: 'solid',
    color: [255, 255, 0, 0.05], //--Celeste
    outline: {
      color: [255, 255, 0],   //--Celeste
      width: 1.5
    }
  },
  symbolEditLine: {
    type: 'simple-line',
    style: 'solid',
    color: [12, 254, 254],    //--Celeste
    width: 2
  },
  symbolSelectLine: {
    type: 'simple-line',
    style: 'solid',
    color: [255, 255, 0,], //--amarrillo
    width: 2
  },
  menuData: [
    {
      id: "bosque",
      icon: "fi fi-ss-tree-deciduous",
      title: "Bosque y pérdida de bosque",
      info: "",
      tooltip: "",
      services: [
        {
          title: "Bosque Húmedo Amazónico",
          info: "https://geobosques.bosques.gob.pe/geobosques/bosque-perdida-bosque",
          tooltip: "Muestra la perdida",
          subservices: [
            {
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_bosque_humedo/MapServer',
              title: 'Bosque al 2024',
              id: 'bosque-2024',
              visible: true,
              color: 'green',
              legend: false,
              services: []
            },
            {
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_no_bosque/MapServer',
              title: 'No bosque al 2000',
              id: 'nobosque-2020',
              visible: true,
              color: '#ffb600',
              legend: false,
              services: []
            },
            {
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_perdida_bosque_humedo/MapServer',
              title: 'Pérdida de bosque 2001-2024',
              id: 'perdida-2021',
              visible: true,
              color: 'red',
              legend: false,
              services: []
            }
          ]
        },
        {
          title: "Bosque Estacionalmente Seco",
          info: "https://geobosques.bosques.gob.pe/geobosques/bosque-perdida-bosque",
          tooltip: "Muestra la perdida",
          subservices: [
            {
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_bosque_seco/MapServer',
              title: 'Bosque estacionalmente seco',
              id: 'bosque-seco',
              visible: false,
              color: '#84B509',
              legend: false,
              services: []
            },
            {
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_bosque_tropical/MapServer',
              title: 'Bosque tropical del Pacífico',
              id: 'bosque-tropical',
              visible: false,
              color: '#4ECF70',
              legend: false,
              services: []
            },
            {
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_perdida_bosque_seco/MapServer',
              title: 'Pérdida de bosque',
              id: 'bosque-perdida',
              visible: false,
              color: '#AC2F2F',
              legend: false,
              services: []
            }
          ]
        },
      ]
    },
    {
      id: 'alertas',
      title: 'Alertas tempranas',
      icon: 'fi-sr-light-emergency-on',
      info: "",
      tooltip: "Muestra la perdida",
      services: [{
        title: "Alertas tempranas",
        info: "",
        tooltip: "Muestra la perdida",
        subservices: [
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_alertas_concentracion/MapServer',
            title: 'Concentración de alertas tempranas',
            id: 'alerta-concentracion',
            visible: true,
            color: '#D8D8D8',
            legend: false,
            services: []
          },
          {
            url: '',
            title: 'Alertas tempranas 2026',
            id: 'alerta-2026',
            visible: false,
            color: '#E63341',
            legend: false,
            services: [{
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_alertas_acumuladas/MapServer',
              title: 'Acumulado',
              id: 'acumulado-2026',
              visible: false,
              color: '#3965BF',
            }, {
              url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_alertas_ultima_sem/MapServer',
              title: 'Última semana',
              id: 'ultima-2026',
              visible: false,
              color: '#E63341',
            }]
          }
        ]
      }, {
        title: "Caminos detectados",
        info: "",
        tooltip: "Muestra la perdida",
        subservices: [
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_caminos/MapServer',
            title: 'Caminos detectados',
            id: 'alerta-caminos',
            visible: false,
            color: '#005A2B',
            legend: false,
            services: []
          },
        ]
      },
      {
        title: "Alertas RAMI",
        info: "",
        tooltip: "Muestra la perdida",
        subservices: [
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_alertas_rami_2025/MapServer',
            title: 'Alertas RAMI 2025',
            id: 'rami-2025',
            visible: false,
            color: '#E63341',
            legend: false,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_alertas_rami_2024/MapServer',
            title: 'Alertas RAMI 2024',
            id: 'rami-2024',
            visible: false,
            color: '#FFFF3B',
            legend: false,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_alertas_rami_2023/MapServer',
            title: 'Alertas RAMI 2023',
            id: 'rami-2023',
            visible: false,
            color: '#EEBF2C',
            legend: false,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_alertas_rami_2022/MapServer',
            title: 'Alertas RAMI 2022',
            id: 'rami-2022',
            visible: false,
            color: '#BF4B21',
            legend: false,
            services: []
          },
        ]
      }
      ]
    },
    {
      id: 'uso',
      title: 'Uso y cambio de uso',
      icon: 'fi fi-sr-mountain',
      info: "",
      tooltip: "Muestra la perdida",
      services: [{
        title: "Uso y cambio de uso",
        info: "",
        tooltip: "Muestra la perdida",
        subservices: [
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_uso_cambio_uso_2020/MapServer',
            title: 'Cambio de uso 2020',
            id: 'cambio-2020',
            visible: false,
            color: '#005A2B',
            legend: true,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_uso_cambio_uso_2018/MapServer',
            title: 'Cambio de uso 2018',
            id: 'cambio-2018',
            visible: false,
            color: '#005A2B',
            legend: true,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_uso_cambio_uso_2016/MapServer',
            title: 'Cambio de uso 2016',
            id: 'cambio-2016',
            visible: false,
            color: '#005A2B',
            legend: true,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_uso_cambio_uso_2014/MapServer',
            title: 'Cambio de uso 2014',
            id: 'cambio-2014',
            visible: false,
            color: '#005A2B',
            legend: true,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_uso_cambio_uso_2012/MapServer',
            title: 'Cambio de uso 2012',
            id: 'cambio-2012',
            visible: false,
            color: '#005A2B',
            legend: true,
            services: []
          },
          {
            url: 'https://gis.bosques.gob.pe/server/rest/services/Geobosques_Visor/serv_geobosques_visor_uso_cambio_uso_2010/MapServer',
            title: 'Cambio de uso 2010',
            id: 'cambio-201',
            visible: false,
            color: '#005A2B',
            legend: true,
            services: []
          },
        ]
      },]
    }
  ]
};
